import EmptyContent from '@/commons/empty-content/EmptyContent';
import { parseUserDate, translates } from '@/utils';
import { currentFormat } from '@/utils/cases';
import {
  Timeline,
  TimelineConnector,
  TimelineContent,
  TimelineDot,
  TimelineItem,
  TimelineSeparator,
  timelineItemClasses,
} from '@mui/lab';
import { Box, Stack, Typography } from '@mui/material';
import dayjs from 'dayjs';

export default function CashRegisterTimeLine({ data }: any) {
  if (!data?.length) {
    return (
      <Stack justifyContent="center" alignItems="center">
        <EmptyContent
          title={translates.noData}
          sx={{
            '& span.MuiBox-root': { height: 160 },
          }}
        />
      </Stack>
    );
  }
  return (
    <Timeline
      placeholder=""
      onPointerEnterCapture={undefined}
      onPointerLeaveCapture={undefined}
      sx={{
        p: 0,
        m: 0,
        [`& .${timelineItemClasses.root}:before`]: {
          flex: 0,
          padding: 2,
        },
      }}
    >
      {data.map((item: any) => {
        const { isWithdrawal, cash, comment, created_at: createdAt, responsibleName, _id } = item;
        const title = isWithdrawal ? 'Retiro' : 'Deposito';

        return (
          <TimelineItem>
            <TimelineSeparator>
              <TimelineDot variant="filled" color={isWithdrawal ? 'error' : 'success'} />
              <TimelineConnector />
            </TimelineSeparator>

            <TimelineContent>
              <Typography variant="subtitle2" fontWeight={400}>
                <strong>{title}</strong> - {_id.slice(0, 7)}
              </Typography>

              <Box sx={{ color: 'text.disabled', typography: 'caption', mt: 0.5 }}>
                {currentFormat(Math.abs(cash))}
              </Box>
              <Box sx={{ color: 'text.disabled', typography: 'caption', mt: 0.5 }}>{comment}</Box>
              <Box sx={{ color: 'text.disabled', typography: 'caption', mt: 0.5 }}>
                {parseUserDate(createdAt).format('DD/MM/YY hh:mm A')}
              </Box>
              <Box sx={{ color: 'text.disabled', typography: 'caption', mt: 0.5 }}>
                {responsibleName}
              </Box>
            </TimelineContent>
          </TimelineItem>
        );
      })}
    </Timeline>
  );
}
